// extracted by mini-css-extract-plugin
module.exports = {"desktopSearch":"Search-module--desktopSearch--2xr5L","added":"Search-module--added--zr_EV","signupResponse":"Search-module--signup-response--XDzTw"};